"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotAddedChannelCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const BotAddedChannelCard = () => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Accent,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Large,
        text: "👋 Hi There, I'm Polly!",
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Accent,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Medium,
        text: "A teammate of yours recently added me to help your team gather feedback!",
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        url: "https://static.polly.ai/teams/img/polly-channel-bot-added.png",
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        height: 400,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        size: adaptivecards_1.TextSize.Medium,
        weight: adaptivecards_1.TextWeight.Bolder,
        spacing: adaptivecards_1.Spacing.Large,
        text: "Here are some of the things I can do:",
        wrap: true,
    }));
    const factSet = new adaptivecards_1.FactSet();
    factSet.facts.push(new adaptivecards_1.Fact("*", "Gather valuable feedback from your teammates directly in Microsoft Teams"));
    factSet.facts.push(new adaptivecards_1.Fact("*", "Provide powerful questions, quizzes, and feedback directly in meetings"));
    factSet.facts.push(new adaptivecards_1.Fact("*", "Add Polly as a tab to explore results and manage pollys"));
    card.addItem(factSet);
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.OpenUrlAction, {
        title: "Learn more",
        url: "https://www.polly.ai/microsoft-teams",
    }));
    return card;
};
exports.BotAddedChannelCard = BotAddedChannelCard;
//# sourceMappingURL=BotAddedChannelCard.js.map